import {connect} from './connect';
import {forward} from './forward';

export function createEmitter(): Emitter {
  let listeners: Listeners = [];

  return {
    connect(...services: Listeners) {
      listeners = connect(listeners, services);
    },
    emit(message: Message) {
      forward(message, listeners);
    },
  };
}
